<template>
    <fieldset class="border px-3 mb-3">
        <legend class="w-auto">
            <i class="fas fa-info-circle text-muted"
               style=""
               data-toggle="tooltip"
               data-placement="top"
               :title="$info['filter.pharmacies']"></i>
            Apotheken
        </legend>

        <div class="form-group">
            <label>Liste hochladen</label>
            <input type="file" class="form-control-file" accept=".xlsx,.xls" @change="pharmaciesUpload"
                   ref="pharmaciesFile">
            <div v-if="errors" class="text-danger">
                <ul>
                    <li v-for="error in errors">
                        <span :title="JSON.stringify(error.row)">Zeile {{ error.index + 1 }}:</span>
                        {{ error.message }}
                    </li>
                </ul>
            </div>
            <div class="mt-1">
                <a href="/files/Vorlage_Apotheken.xlsx">
                    <small>
                        <i class="fas fa-fw fa-download"></i>
                        Download Vorlage
                    </small>
                </a>
                <a href="#" @click.prevent="addPharmacyByBgas">
                    <small>
                        <i class="fas fa-fw fa-user-edit"></i>
                        BGA hinzufügen
                    </small>
                </a>
                <a href="#" @click.prevent="listSelectVisible = true" v-if="!listSelectVisible">
                    <small>
                        <i class="fas fa-fw fa-user-edit"></i>
                        Liste hinzufügen
                    </small>
                </a>
                <a href="#" v-for="coop in options.coops" @click.prevent="addPharmaciesByCoop(coop)">
                    <small>
                        <i class="fas fa-fw fa-plus-circle"></i>
                        Alle {{ options.coops.length > 1 ? coop : 'Apotheken' }}
                    </small>
                </a>
            </div>

            <div class="mt-1" v-if="listSelectVisible">
                <div v-if="!pharmacyLists.length">Noch keine Listen vorhanden!</div>
                <button type="button"
                        class="btn btn-sm btn-primary mr-1"
                        v-for="list in pharmacyLists"
                        v-show="!config[dtoKey + 'Lists'].includes(list.id)"
                        @click="addFromList(list.id)">
                    {{ list.title }} ({{ list.config.content.length }})
                </button>
                <button type="button"
                        class="btn btn-sm btn-primary"
                        @click="listSelectVisible = false">
                    Abbrechen
                </button>
            </div>
        </div>

        <div class="mb-3">
            <div v-if="config[dtoKey].length || config[dtoKey + 'Lists'].length">
                {{ config[dtoKey].length }} Apotheken ausgewählt
                <a href="#" @click.prevent="itemsVisible = !itemsVisible">
                    <i class="fas fa-fw" :class="{'fa-eye': !itemsVisible, 'fa-eye-slash': itemsVisible}"></i>
                </a>
                <table class="table table-sm table-bordered mt-2 mb-0" v-if="itemsVisible">
                    <thead>
                    <tr>
                        <th>BGA</th>
                        <th>Name</th>
                        <th>Ort</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in config[dtoKey]">
                        <td>{{ item.bga }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.city }}</td>
                    </tr>
                    </tbody>
                </table>
                <br>
                <template v-if="config[dtoKey + 'Lists'].length">
                    {{ config[dtoKey + 'Lists'].length }} Listen ausgewählt
                    (
                    <template v-for="list in selectedPharmacyLists">
                        <a :href="'/lists/' + list.id + '/edit'" target="_blank">
                            {{ list.title }}
                        </a>
                    </template>
                    )
                    <br>
                </template>
                <small>
                    <a href="#" @click.prevent="config[dtoKey] = []; config[dtoKey + 'Lists'] = [];">Leeren</a>
                </small>
            </div>
            <div v-else class="text-muted">
                Noch keine Apotheken ausgewählt
            </div>
        </div>

        <div class="form-group" v-show="mode">
            <label>
                <b>Startdatum Modus</b>
            </label>
            <select class="form-control" v-model="config[modeKey]">
                <option value="full">Gesamtzeitraum</option>
                <option value="quarterly-start">Quartalsweise - Anfang</option>
                <option value="quarterly-middle">Quartalsweise - Mitte</option>
                <option value="quarterly-end">Quartalsweise - Ende</option>
                <option value="monthly">Monatlich</option>
            </select>
        </div>

        <div class="form-group" v-show="coopSplit">
            <label>
                <b>Kooperationen</b>
            </label>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="config[coopSplitKey]" value="" id="pharmacy-filter-coop-split">
                <label class="form-check-label" for="pharmacy-filter-coop-split">
                    Kooperationen aufsplitten
                </label>
            </div>
        </div>
    </fieldset>
</template>

<script>

export default {
    components: {},
    props: {
        dto: {
            type: Object,
            required: true
        },
        dtoKey: {
            type: String,
            default: 'pharmacies'
        },
        mode: {
            type: Boolean,
            default: false
        },
        modeKey: {
            type: String,
            default: 'pharmaciesMode'
        },
        coopSplit: {
            type: Boolean,
            default: false
        },
        coopSplitKey: {
            type: String,
            default: 'pharmaciesCoopSplit'
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
            listSelectVisible: false,
            itemsVisible: false,
            errors: null,
        };
    },
    methods: {
        pharmaciesUpload() {
            this.errors = null;
            const file = this.$refs.pharmaciesFile.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const headers = {'Content-Type': 'multipart/form-data'};
            axios.post('/files/pharmacies', formData, {headers}).then((res) => {
                this.config[this.dtoKey] = res.data;
            }).catch((error) => {
                const importError = error.response.data.import_errors || false;
                if (importError) {
                    this.errors = error.response.data.errors;
                } else {
                    console.log(error);
                    alert("Unbekannter Fehler");
                }

            }).finally(() => {
                this.$refs.pharmaciesFile.value = '';
            });
        },
        addPharmaciesByCoop(coop) {
            axios.get('/select/coops/' + coop + '/pharmacies').then((res) => {
                res.data.forEach((newPharmacy) => {
                    if (!this.config[this.dtoKey].some(pharmacy => parseInt(pharmacy.bga) === parseInt(newPharmacy.bga))) {
                        this.config[this.dtoKey].push(newPharmacy);
                    }
                });
            });
        },
        addPharmacyByBgas() {
            const bgas = window.prompt('BGA');
            if (bgas) {
                axios.get('/select/pharmacies/from-bgas?bgas=' + bgas).then((res) => {
                    const newPharmacies = res.data;
                    newPharmacies.forEach((newPharmacy) => {
                        if (newPharmacy.bga && !this.config[this.dtoKey].some(pharmacy => parseInt(pharmacy.bga) === parseInt(newPharmacy.bga))) {
                            this.config[this.dtoKey].push(newPharmacy);
                        }
                    });
                });
            }
        },
        addFromList(listId) {
            if (!this.config[this.dtoKey + 'Lists'].includes(listId)) {
                this.config[this.dtoKey + 'Lists'].push(listId);
            }
            this.listSelectVisible = false;
        }
    },
    computed: {
        pharmacyLists() {
            return (this.options.lists['pharmacies'] || []);
        },
        selectedPharmacyLists() {
            return this.pharmacyLists.filter((list) => {
                return this.config[this.dtoKey + 'Lists'].includes(list.id);
            });
        }
    }
}
</script>
